module.exports = __webpack_public_path__ + "files/3ed938e824937f83272d9a357c279f46.png";